import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

const SocialLinks = ({ info, className = '', iconSize = 20 }) => {
  const ig = info?.instagram;
  const fb = info?.facebook;
  if (!ig && !fb) return null;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {ig && (
        <a
          href={ig}
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
          className="w-10 h-10 rounded-full border-[1.5px] border-black flex items-center justify-center hover:bg-black hover:text-white transition"
        >
          <Instagram size={iconSize} />
        </a>
      )}
      {fb && (
        <a
          href={fb}
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook"
          className="w-10 h-10 rounded-full border-[1.5px] border-black flex items-center justify-center hover:bg-black hover:text-white transition"
        >
          <Facebook size={iconSize} />
        </a>
      )}
    </div>
  );
};

export default SocialLinks;
